export default {
  savings: 'https://spendid.io/get-advice?site=iframe',
  mortgage_and_rent: 'https://spendid.io/get-advice?site=iframe/#mortgageid',
  vehicle_purchase_and_lease: 'https://spendid.io/get-advice?site=iframe/#carpaymentid',
  other_debt_payments: 'https://spendid.io/get-advice?site=iframe/#debtid',
  life_and_personal_insurance: 'https://spendid.io/get-advice?site=iframe/#lifepersonalid',
  cash_contributions: 'https://spendid.io/get-advice?site=iframe/#charitableid',
  miscellaneous: 'https://spendid.io/get-advice?site=iframe/#miscellaneousid',
  tobacco_and_smoking: 'https://spendid.io/get-advice?site=iframe/#miscellaneousid',
  education: 'https://spendid.io/get-advice?site=iframe/#educationid',
  reading: 'https://spendid.io/get-advice?site=iframe/#miscellaneousid',
  personal_care: 'https://spendid.io/get-advice?site=iframe/#personcalcareid',
  toys_and_hobbies: 'https://spendid.io/get-advice?site=iframe/#funid',
  pets: 'https://spendid.io/get-advice?site=iframe/#petsid',
  media_hardware_and_services: 'https://spendid.io/get-advice?site=iframe/#cableid',
  fees_and_admissions: 'https://spendid.io/get-advice?site=iframe/#funid',
  medical_supplies: 'https://spendid.io/get-advice?site=iframe/#medicalid',
  prescription_drugs: 'https://spendid.io/get-advice?site=iframe/#medicalid',
  medical_services: 'https://spendid.io/get-advice?site=iframe/#medicalid',
  health_insurance: 'https://spendid.io/get-advice?site=iframe/#healthid',
  public_and_other_transportation: 'https://spendid.io/get-advice?site=iframe/#transportid',
  vehicle_insurance: 'https://spendid.io/get-advice?site=iframe/#carinsuranceid',
  vehicle_maintenance_and_repairs: 'https://spendid.io/get-advice?site=iframe/#carmaintenanceid',
  gasoline: 'https://spendid.io/get-advice?site=iframe/#gasolineid',
  clothing_items_and_services: 'https://spendid.io/get-advice?site=iframe/#clothingid',
  furniture_and_appliances: 'https://spendid.io/get-advice?site=iframe/#furnitureid',
  housekeeping_supplies: 'https://spendid.io/get-advice?site=iframe/#maintenanceid',
  other_household_expenses: 'https://spendid.io/get-advice?site=iframe/#maintenanceid',
  water_and_public_services: 'https://spendid.io/get-advice?site=iframe/#utilitiesid',
  telephone_services: 'https://spendid.io/get-advice?site=iframe/#pserviceid',
  residential_phone_service: 'https://spendid.io/get-advice?site=iframe',
  heating_fuels_other: 'https://spendid.io/get-advice?site=iframe/#utilitiesid',
  electricity: 'https://spendid.io/get-advice?site=iframe/#powerbillid',
  natural_gas: 'https://spendid.io/get-advice?site=iframe/#utilitiesid',
  other_lodging: 'https://spendid.io/get-advice?site=iframe/#vacationid',
  home_maintenance_and_repairs: 'https://spendid.io/get-advice?site=iframe/#maintenanceid',
  alcoholic_beverages: 'https://spendid.io/get-advice?site=iframe',
  food_out: 'https://spendid.io/get-advice?site=iframe/#diningid',
  food_home: 'https://spendid.io/get-advice?site=iframe/#groceriesid',
  personal_services:'https://spendid.io/get-advice?site=iframe/#babyid'
}
